module.exports = __webpack_public_path__ + "img/mail.347c4917.webp";